import { read, utils } from 'xlsx';

export function getMatrixFromXLSX(blob) {
  const workbook = read(blob, { type: 'array' });
  return utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
    header: 1,
  });
}
